import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCpu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M5 6a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -12" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 9h6v6h-6l0 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 10h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 14h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 3v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 3v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 10h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 14h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 21v-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 21v-2" })
	]
});
export { SvgCpu as ReactComponent };
